// extracted by mini-css-extract-plugin
export default {"component":"yQX-4"};